const initialState = {
    step: 1,
    maxSteps: 6,
    user: {},
    formData: {
      needFreight: true,
      property_type: 'house',
      how_download: 'stairs',
      plan: 6
    }
}
  
const forms = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_STEP':
          return Object.assign({}, state, {
            step: action.payload
          })
        case 'SET_MAX_STEP':
          return Object.assign({}, state, {
            maxSteps: action.payload
          })
        case 'UPDATE_FORMDATA':
          
          var newFormData = Object.assign({},state.formData,action.payload)
          
          return Object.assign({}, state, {
            formData: newFormData
          })
        case 'UPDATE_USERDATA':
          
          var newUserData = Object.assign({},state.user,action.payload)
          
          return Object.assign({}, state, {
            user: newUserData
          })
        case 'REINIT_FORMDATA': {
          return Object.assign({}, state, {
            step: 1,
            maxSteps: 6,
            formData: {
              needFreight: true,
              plan: 6
            }
          })
        }
        default:
          return state
    }
}
    
    export default forms